import { getConfig, saveOrModify } from '@/services/internal/facility/config/VendorRtnLimitConfig';

export default {
  namespace:'vendorRtnLimitConfig',
  state:{
  },

  effects:{
    *getConfigByDcUuid({payload,callback},{call}){
     const response= yield call(getConfig);
      if (callback) callback(response)
    },

    *saveOrModifyConfig({payload,callback},{call,put}){
      const response=yield call(saveOrModify,payload);
      if (callback) callback(response)
    }
  },

  reducers: {

  }
}
